import { classNames, twMerge } from '@panwds/tailwindcss';
import { pathMatch } from '../../utils/pathMatchHelper.js';
export const navigationV3Classes = {
    root: 'twds-box-border twds-w-screen twds-h-screen twds-flex twds-bg-steel-gray-850',
    brandColor: 'twds-fill-steel-gray-100',
    mainNav: {
        root: {
            dimension: 'twds-h-full',
            box: 'twds-box-border',
            flex: 'twds-shrink-0 twds-flex'
        },
        divider: {
            dimension: 'twds-h-[1px]',
            background: 'twds-bg-[#ffffff1a]',
            spacing: 'twds-ml-4',
            animation: 'twds-transition-all twds-duration-200 twds-ease-in-out'
        }
    },
    navWrapper: {
        box: 'twds-box-border',
        display: 'twds-flex',
        layout: 'twds-flex-col',
        dimension: 'twds-h-full'
    },
    nav: {
        root: {
            position: 'twds-relative',
            display: 'twds-flex',
            layout: 'twds-flex-col twds-flex-1',
            box: 'twds-box-border',
            spacing: 'twds-mt-2',
            overflow: 'twds-overflow-hidden'
        },
        openItems: {
            dimension: 'twds-w-full'
        },
        navbar: {
            boxSizing: 'twds-box-border',
            flex: 'twds-flex twds-flex-col twds-justify-between twds-flex-1',
            dimension: 'twds-min-h-0'
        }
    },
    appContainer: {
        box: 'twds-box-border',
        dimension: 'twds-w-full',
        spacing: 'twds-mt-2 twds-mr-2 twds-mb-2',
        background: 'twds-bg-gray-50 dark:twds-bg-gray-1050',
        overflow: 'twds-overflow-hidden',
        border: 'twds-rounded-lg',
        boxShadow: '0px 2px 8px 0px rgba(20, 26, 31, 0.88)'
    },
    subMenuWrapper: {
        box: 'twds-box-border',
        position: 'twds-absolute',
        spacing: 'twds-ml-[4rem]',
        dimension: 'twds-h-full'
    }
};
function getOpenItemsClasses() {
    return classNames(navigationV3Classes.nav.openItems.dimension);
}
export function getMainNavClasses() {
    return classNames(navigationV3Classes.mainNav.root.dimension, navigationV3Classes.mainNav.root.box, navigationV3Classes.mainNav.root.flex);
}
export function getNavWrapperClasses(className) {
    return twMerge(navigationV3Classes.navWrapper.box, navigationV3Classes.navWrapper.display, navigationV3Classes.navWrapper.layout, navigationV3Classes.navWrapper.dimension, className);
}
export function getNavClasses(collapsed, className) {
    return twMerge(navigationV3Classes.nav.root.box, navigationV3Classes.nav.root.display, navigationV3Classes.nav.root.layout, navigationV3Classes.nav.root.position, navigationV3Classes.nav.root.spacing, navigationV3Classes.nav.root.overflow, !collapsed && getOpenItemsClasses(), className);
}
export function getNavigationRootClasses(className) {
    return twMerge(navigationV3Classes.root, className);
}
export function getNavBarClasses() {
    return classNames(navigationV3Classes.nav.navbar.boxSizing, navigationV3Classes.nav.navbar.dimension, navigationV3Classes.nav.navbar.flex);
}
export function getMainNavDividerClasses() {
    return classNames(navigationV3Classes.mainNav.divider.dimension, navigationV3Classes.mainNav.divider.background, navigationV3Classes.mainNav.divider.spacing, navigationV3Classes.mainNav.divider.animation);
}
export function getNavigationCollapseDividerClasses(collapsed) {
    return classNames(getMainNavDividerClasses(), collapsed ? 'twds-w-8' : 'twds-w-[15.5rem]');
}
export function getAppContainerClasses(className) {
    return twMerge(navigationV3Classes.appContainer.box, navigationV3Classes.appContainer.dimension, navigationV3Classes.appContainer.spacing, navigationV3Classes.appContainer.background, navigationV3Classes.appContainer.overflow, navigationV3Classes.appContainer.border, className);
}
export function getAppContainerBoxShadow() {
    return navigationV3Classes.appContainer.boxShadow;
}
export function getSubMenuWrapperClasses() {
    return classNames(navigationV3Classes.subMenuWrapper.box, navigationV3Classes.subMenuWrapper.position, navigationV3Classes.subMenuWrapper.spacing, navigationV3Classes.subMenuWrapper.dimension);
}
const defaultSelectionState = {
    selectedNav: undefined,
    selectedSubNav: undefined,
    selectedNavUrl: undefined,
    selectedSubNavUrl: undefined
};
const findRecursiveById = (items, parent, defaultId) => {
    for (const item of items) {
        if (item.id === defaultId) {
            return {
                selectedNav: parent?.id || item.id,
                selectedNavUrl: parent?.url || item.url,
                selectedSubNav: parent ? item.id : undefined,
                selectedSubNavUrl: parent ? item.url : undefined
            };
        }
        if (item.children) {
            const result = findRecursiveById(item.children, parent || item, defaultId);
            if (result.selectedNav !== undefined) {
                return result;
            }
        }
    }
    return defaultSelectionState;
};
export function findSelectedItemsById(items, defaultId) {
    if (!defaultId) {
        return defaultSelectionState;
    }
    return findRecursiveById(items, undefined, defaultId);
}
const checkIdRecursive = (items, ids) => {
    for (const item of items) {
        if (ids.has(item.id)) {
            console.error(`Duplicate id found: ${item.id}`);
        }
        ids.add(item.id);
        if (item.children) {
            checkIdRecursive(item.children, ids);
        }
    }
};
export function validateUniqueId(navConfig) {
    const ids = new Set();
    checkIdRecursive(navConfig, ids);
}
const findRecursiveByUrl = (items, parent, defaultUrl) => {
    for (const item of items) {
        if (pathMatch(defaultUrl, item.url)) {
            return {
                selectedNav: parent?.id || item.id,
                selectedNavUrl: parent?.url || item.url,
                selectedSubNav: parent ? item.id : undefined,
                selectedSubNavUrl: parent ? item.url : undefined
            };
        }
        if (item.children) {
            const result = findRecursiveByUrl(item.children, parent || item, defaultUrl);
            if (result.selectedNav !== undefined) {
                return result;
            }
        }
    }
    return defaultSelectionState;
};
export function findSelectedItemsByUrl(items, defaultUrl) {
    if (!defaultUrl) {
        return defaultSelectionState;
    }
    return findRecursiveByUrl(items, undefined, defaultUrl);
}
//# sourceMappingURL=navigationV3.logic.js.map